import React from 'react';
import { Link } from 'gatsby';

const DevOpsBanner = ({
  customTitle,
  customSubtitle,
  customBtnText,
  version
}) => {
  return (
    <div className="main-banner suspend">
      <div
        className={`left-section ${
          version === 'bigger' ? 'custom-padding' : ''
        }`}
      >
        <div
          className={`body ${
            version === 'servicesPage' ? 'banner-pillar' : ''
          }`}
        >
          <h2 className="tt">{customTitle}</h2>
          {version === 'servicesPage' ? (
            ''
          ) : (
            <div className="dd">{customSubtitle}</div>
          )}
        </div>
      </div>
      <div
        className={`right-section ${
          version === 'bigger' ? 'custom-padding' : ''
        }`}
      >
        <Link
          to={`${version === 'servicesPage' ? '/contact/' : '/how-we-work/'}`}
          className={`btn btn-main ${version === 'servicesPage' ? 'fill' : ''}`}
        >
          {version === 'servicesPage'
            ? `${customBtnText || 'Contact us'} `
            : 'See our workflow'}
        </Link>
      </div>
    </div>
  );
};

export default DevOpsBanner;

DevOpsBanner.defaultProps = {
  customTitle: 'Do you know how we work?',
  customSubtitle: 'Check it out!'
};
